import React, { useEffect } from 'react';
import WOW from 'wow.js';
import 'animate.css/animate.css';
import { useForm, ValidationError } from "@formspree/react";

const ContactForm = () => {

  useEffect(() => {
    const wow = new WOW();
    wow.init();
  }, []);

  const [state, handleSubmit] = useForm("xwkjdvgk");

  if (state.succeeded) {
    return (
      <div className="contact-section">
        <div className="contact-section-inner">
          <h2 className="section-heading main-title contact-head wow animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">Contact Us Now</h2>
          <div className="contact-form">
            <p>
              Thanks for contacting us! We have received your response and will get back to you as soon as possible.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-section" id="contactus">
      <div className="contact-section-inner">
        <h2 className="section-heading main-title contact-head wow animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">Contact Us Now</h2>
        <div className="contact-section-inner-content">
        <div className="contact-form wow animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
          <form onSubmit={handleSubmit}>
            <input id="name" type="text" name="name" placeholder="Name" />
            <ValidationError prefix="Name" field="name" errors={state.errors} />
            <input id="email" type="email" name="email" placeholder="Email" />
            <ValidationError
              prefix="Email"
              field="email"
              errors={state.errors}
            />

            <textarea id="message" name="message" placeholder="Message" />
            <ValidationError
              prefix="Message"
              field="message"
              errors={state.errors}
            />

            <button className="button" type="submit" disabled={state.submitting}>
              Submit
            </button>
          </form>
        </div>
        <div className='map-section'>
    <div className="map-section-inner wow animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.5s">
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d217897.62046213722!2d72.92448641398784!3d31.423759041722196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x392242a895a55ca9%3A0xdec58f88932671c6!2sFaisalabad%2C%20Punjab%2C%20Pakistan!5e0!3m2!1sen!2s!4v1687160411555!5m2!1sen!2s" width="100%" height="450" style={{border:0}} allowFullScreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
